import * as React from "react";
import {Fragment} from "react";
import {withRouter} from "react-router-dom";
import SFXButtonComponent from "../../../components/SFXButtonComponent";
import {Card, Col, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import PasswordResetService from "../../../services/PasswordResetService";
import ToastHelper from "../../../utils/ToastHelper";
import UserSessionService from "../../../services/UserSessionService";

class ChangePassword extends React.Component {

    constructor(props) {
        super(props);

        this.username = this.props.customer.msisdnValue;

        this.state = {
            oldPassword: "",
            newPassword: "",
            confirmNewPassword: "",

            isModalShowing: false
        }
    }

    componentDidMount() {
        this.props.setHeader("Change Pin")
    }

    handleChange(event) {

        this.setState({
            [event.target.id]: event.target.value
        })

    }

    isFormValid() {
        return ((this.isFieldValid(this.state.oldPassword))
            && (this.isFieldValid(this.state.newPassword))
            && (this.isFieldValid(this.state.confirmNewPassword))
            && (this.state.newPassword === this.state.confirmNewPassword));
    }

    isFieldValid(field) {
        return ((field.length === 4) && (!isNaN(field)))
    }

    toggleModal(){
        this.setState({
            isModalShowing: !this.state.isModalShowing
        });
    }

    pinChangeAcknowledgement(){
        this.props.history.replace("/logout");
    }

    changePassword() {

        PasswordResetService.changePassword(this.username, this.state.oldPassword, this.state.newPassword).then(response => {
            if(response === "success"){
                this.toggleModal();
                UserSessionService.logout();
            }
            else{
                ToastHelper.formatError("Invalid Pin entered");
            }
        })
    }

    render() {

        return <Fragment>
            {this.renderModal()}

            {this.props.isMobile ? this.renderContent("mobile") : this.renderContentBrowser("browser")}

        </Fragment>
    }

    renderContent(className) {

        return <Fragment>

            <div>
                {this.renderPasswordInformation(className)}

                {this.renderInput(className, "oldPassword", "Old Pin")}
                {this.renderInput(className, "newPassword", "New Pin")}
                {this.renderInput(className, "confirmNewPassword", "Confirm New Pin")}

                {this.renderUpdatePasswordButton(className)}
            </div>

        </Fragment>
    }

    renderPasswordInformation(className) {

        return <Fragment>

            <div style={{padding: "5px"}}>
                <Card>
                    <p style={{paddingLeft: "5px", color: "grey", fontWeight: "bold"}}>How Do I Change My Pin?</p>
                    {<ul style={{fontSize: "14px"}}>
                        <li>Enter your current 4 digit pin in the 'Old Pin' field.</li>
                        <li>Then, please enter your new 4 digit pin in the 'New Pin' field.</li>
                        <li>Enter your new 4 digit pin again in the 'Confirm Pin' field.</li>
                    </ul>}
                </Card>
            </div>

        </Fragment>

    }

    renderInput(className, field, text) {

        return <Fragment>

            <Row className={className + "_row"}>
                <Col>
                    <Input
                        type={"password"}
                        className={className + "_input"}
                        value={this.state[field] || ""}
                        placeholder={text}
                        id={field}
                        onChange={(event) => this.handleChange(event)}
                    />
                </Col>
            </Row>

        </Fragment>

    }

    renderUpdatePasswordButton(className) {

        return <div className={className + "_register_button_div"}>
            <SFXButtonComponent
                className={className + "_orange_oval_button"}
                onClick={() => this.changePassword()}
                disabled={!this.isFormValid()}
            >Change Pin
            </SFXButtonComponent>
        </div>
    }

    //BROWSER VIEW
    renderContentBrowser(className) {

        return <Card style={{
            boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
            borderRadius: "15px",
            width: "55%",
            margin: "auto"
        }}>

            <div>
                {this.renderPasswordInformationBrowser(className)}

                <div style={{width: "75%", margin: "auto"}}>
                {this.renderInput(className, "oldPassword", "Old Pin")}
                {this.renderInput(className, "newPassword", "New Pin")}
                {this.renderInput(className, "confirmNewPassword", "Confirm New Pin")}
                </div>
<br />
                {this.renderUpdatePasswordButton(className)}
            </div>

        </Card>
    }

    renderPasswordInformationBrowser(className) {

        return <Fragment>

            <div style={{padding: "5px", paddingTop: "15px", width: "85%", margin: "auto"}}>
                <Card style={{border: "none"}}>
                    <p style={{paddingLeft: "5px", color: "grey", fontWeight: "bold"}}>How Do I Change My Pin?</p>
                    {<ul style={{fontSize: "14px"}}>
                        <li>Enter your current 4 digit pin in the 'Old Pin' field.</li>
                        <li>Then, please enter your new 4 digit pin in the 'New Pin' field.</li>
                        <li>Enter your new 4 digit pin again in the 'Confirm Pin' field.</li>
                    </ul>}
                </Card>
            </div>

        </Fragment>

    }

    renderModal(className) {
        return <Modal isOpen={this.state.isModalShowing}>

            <ModalHeader className={className + "_modal_header"}>Pin Successfully Changed</ModalHeader>
            <ModalBody>
                You will now need to log back in with your new pin.
            </ModalBody>
            <ModalFooter>
                <SFXButtonComponent
                    onClick={() => this.pinChangeAcknowledgement()}
                >
                    Okay
                </SFXButtonComponent>
            </ModalFooter>

        </Modal>

    }
}

export default withRouter(ChangePassword);